<template>
  <el-dialog :visible.sync="visible" title="完善企业信息" width="40%" @close="close">
    <div class="company-info">
      <el-form :model="localCompany" :rules="rules" ref="companyForm" label-width="160px">
        <el-form-item label="企业名称">
          <div>{{ company_name || '暂无' }}</div>
        </el-form-item>
        <el-form-item label="营业执照信用代码" prop="taxpayer">
          <el-input v-model="localCompany.taxpayer" placeholder="请输入营业执照信用代码"></el-input>
        </el-form-item>
        <el-form-item label="企业详细地址" prop="address">
          <el-input v-model="localCompany.address" placeholder="请输入企业详细地址"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="onSave">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'CompanyInfoModal',
  props: {
    type: { type: String, default: '任务' },
  },
  data() {
    return {
      visible:false,
      localCompany: {},
      company_name: '',
      rules: {
        taxpayer: [
          { required: true, message: '请输入营业执照信用代码', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入企业详细地址', trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    open() {
      this.visible = true;
      let nowCompany = localStorage.getItem("nowCompany")
        ? JSON.parse(localStorage.getItem("nowCompany"))
        : {};
      let nowsettlementInfo = localStorage.getItem("nowsettlementInfo")
        ? JSON.parse(localStorage.getItem("nowsettlementInfo"))
        : {}
        this.company_name = nowCompany.name+nowsettlementInfo.name;
        this.localCompany.company_id = nowCompany.id;
    },
    close() {
      this.$refs.companyForm.resetFields();
      this.visible = false;
    },
    onSave() {
        this.$refs.companyForm.validate((valid) => {
          if (valid) {
            this.formSubmit()
          } else {
            if (this.$message) this.$message.error('请检查必填项');
          }
        });
    },
    // form数据提交，请求接口
    async formSubmit() {
      await this.$api.updateCompanyInfo(this.localCompany)
      this.$nextTick(() => {
        this.$message.success(`企业信息已保存，您可以进行发布${this.type}了`)
        this.$emit('confirm', false);
        this.close()
      })
    },
  }
}
</script>

<style scoped>
.company-info {
  padding: 8px 0;
}
</style>
